import { Outlet } from "react-router-dom";
import { DashboardNavigationItemsContainer } from "@platform/layouts/DashboardNavigation";
import { AppLayout } from "./AppLayout";
import { DashboardAlertBannerContainer } from "@platform/layouts/DashboardAlertBanner";
import { Toast } from "@themes/pollinator/ui/Toast";

export type Props = {
  children?: React.ReactNode;
  title: string;
};

export function DashboardLayout({ children, title }: Props) {
  return (
    <AppLayout
      isWithSidebar
      sidebar={<DashboardNavigationItemsContainer />}
      title={title}
    >
      <DashboardAlertBannerContainer />
      {children ?? <Outlet />}
      {/* Bottom offset reads the StickyActionBar's published height so the
          toast tucks just above the bar when present, or sits in the
          bottom-right corner otherwise. */}
      <Toast
        position="bottom-right"
        offset={{
          bottom: "calc(var(--sticky-action-bar-height, 0px) + 16px)",
          right: 16,
        }}
      />
    </AppLayout>
  );
}

export default DashboardLayout;
